import BasicRewardIcon from '../../assets/svg/quests/rewards/daily/basic-reward.svg';
import BasicRewardHighlightedIcon from '../../assets/svg/quests/rewards/daily/basic-reward-highlighted.svg';
import LargeRewardIcon from '../../assets/svg/quests/rewards/daily/large-reward.svg';
import LargeRewardHighlightedIcon from '../../assets/svg/quests/rewards/daily/large-reward-highlighted.svg';
import MediumRewardIcon from '../../assets/svg/quests/rewards/daily/medium-reward.svg';
import MediumRewardHighlightedIcon from '../../assets/svg/quests/rewards/daily/medium-reward-highlighted.svg';

type TGetRewardIcon = {
  className?: string;
  highlighted?: boolean
}

const getRewardIcon = (order: number, props?: TGetRewardIcon) => {
  if (props?.highlighted) {
    if (order >= 5) {
      return <img src={LargeRewardHighlightedIcon} alt="large-reward-icon" className={props?.className} />;
    }

    if (order >= 3) {
      return <img src={MediumRewardHighlightedIcon} alt="medium-reward-icon" className={props?.className} />;
    }

    return <img src={BasicRewardHighlightedIcon} alt="basic-reward-icon" className={props?.className} />;
  }

  if (order >= 5) {
    return <img src={LargeRewardIcon} alt="large-reward-icon" className={props?.className} />;
  }

  if (order >= 3) {
    return <img src={MediumRewardIcon} alt="medium-reward-icon" className={props?.className} />;
  }

  return <img src={BasicRewardIcon} alt="basic-reward-icon" className={props?.className} />;
};

export default getRewardIcon;
